module.exports = __webpack_public_path__ + "img/report-illust.cc6ac281.jpg";